import React from "react";
import { formatMoneyVN, formatVnd } from "../packageUtils";
import PackageIcon from "./PackageIcon";

export default function FireExplosionPackageButton({ pkg, active, onSelect }) {
  const accentColor = pkg.tierColor || "#EA580C";
  const iconBgColor = pkg.tierBgColor || "#FFEDD5";
  const taglineColor = pkg.tierTaglineColor || accentColor;

  return (
    <button
      type="button"
      className={`fire-explosion__pkg${active ? " fire-explosion__pkg--active" : ""}`}
      onClick={onSelect}
    >
      <div
        className="fire-explosion__pkg-top-bar"
        style={{ backgroundColor: accentColor }}
      />
      <div
        className="fire-explosion__pkg-icon-wrap"
        style={{ backgroundColor: iconBgColor, color: accentColor }}
      >
        <PackageIcon />
      </div>
      <div className="fire-explosion__pkg-label">{pkg.label}</div>
      {pkg.chayNoSumAssured != null ? (
        <div className="fire-explosion__pkg-totalAllSumAssured">
          Cháy nổ {formatMoneyVN(pkg.chayNoSumAssured)}
        </div>
      ) : null}
      {pkg.hangHoaSumAssured != null ? (
        <div className="fire-explosion__pkg-goods-sum">
          Hàng hóa {formatMoneyVN(pkg.hangHoaSumAssured)}
        </div>
      ) : null}
      <div className="fire-explosion__pkg-price">
        {pkg.pricePrefix || ""}
        {formatVnd(pkg.premium)}
      </div>
      {pkg.tierTagline ? (
        <div
          className="fire-explosion__pkg-tagline"
          style={{ color: taglineColor }}
        >
          {pkg.tierTagline}
        </div>
      ) : null}
      {active ? (
        <span className="fire-explosion__pkg-check" aria-hidden>
          ✓
        </span>
      ) : null}
    </button>
  );
}
